import React, { useState, useEffect } from "react";
import "./FatcaCRSDeclaration.modules.css";
import "./YourInvestmentObjectives.modules.css";
// import InvestmentBar from './InvestmentBar/InvestmentBar'
import i18next from "i18next";
import * as Constants from "../../../../constants/Constants";
import * as Helpers from "../../../../global/Helpers";
import * as utils from "../../../../global/utils";
import { useTranslation } from "react-i18next";
import { Slider, Box } from "@mui/material";
import "./InvestmentBar/InvestmentBar.modules.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SessionExpiredPOPup from "../../SessionExpiredPOPup/SessionExpiredPOPup";
import { Redirect } from "react-router-dom";

const FatcaCRSDeclaration5 = (props) => {
  const { t } = useTranslation();
  const [RequestItemsList, setRequestItemsList] = useState([]);
  const [IsCallAPIOnce, setIsCallAPIOnce] = useState(false);

  useEffect(() => {
    ;
    if (IsCallAPIOnce) saveKycDataFun();
  }, [IsCallAPIOnce]);

  const saveKycDataFun = () => {
    ;
    props.saveKycDataAPI(RequestItemsList);
  };

  return (
    <div className="FatcaCRSDeclaration">
      <div className="form-container">
        <form className="dropdown-form">
          <div className="form-group">
            <h5>{t("learn_about_future_goals")} </h5>
            <div className="seekbar-wrapper">
              <NetWorthPercentage setRequestItemsList={setRequestItemsList} IsCallAPI={props.IsCallAPI} setIsCallAPIOnce={setIsCallAPIOnce} setIsCallAPI={props.setIsCallAPI} RequestItemsList={RequestItemsList} />
            </div>
            <hr style={{ width: "80%" }} />
            <div className="seekbar-wrapper">
              <YourInvestmentObjectives setRequestItemsList={setRequestItemsList} IsCallAPI={props.IsCallAPI} setIsCallAPIOnce={setIsCallAPIOnce} setIsCallAPI={props.setIsCallAPI} RequestItemsList={RequestItemsList} />
            </div>
            <hr style={{ width: "80%" }} />
            <div className="seekbar-wrapper">
              <InvestmentBar
                title={t("investment_strategy_and_horizon")}
                setRequestItemsList={setRequestItemsList}
                IsCallAPI={props.IsCallAPI}
                setIsCallAPIOnce={setIsCallAPIOnce}
                setIsCallAPI={props.setIsCallAPI}
                RequestItemsList={RequestItemsList}
              />
            </div>

            <hr style={{ width: "80%" }} />
          </div>
        </form>
      </div>
    </div>
  );
};

const NetWorthPercentage = (props) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");

  const handleClick = (value) => {
    setSelected(value);
  };

  useEffect(() => {
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;

    if (selected === null || selected === "") {
      Helpers.errorNotify(t("Please fill Net Worth Percentage Data"), i18next.language);
      props.setRequestItemsList([]);
      props.setIsCallAPI(false);
      return false;
    }

    return true;
  }

  const saveKycDataFun = () => {
    if (!validateSubmit()) return;
    var arr = props.RequestItemsList;
    arr.push({ ID: "224", Value: selected });
    props.setRequestItemsList(arr);
  };
  return (
    <div className="InvestmentFrequency-container">
      <h2>{t("net_worth_percentage_invested")} </h2>
      <div className="button-group">
        <button
          style={{ marginInline: "2px" }}
          className={`frequency-button ${selected === "1" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("1");
          }}>
          0-25 %
        </button>
        <button
          style={{ marginInline: "2px" }}
          className={`frequency-button ${selected === "2" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("2");
          }}>
          26-50%
        </button>
        <button
          style={{ marginInline: "2px" }}
          className={`frequency-button ${selected === "3" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("3");
          }}>
          51-75%
        </button>
        <button
          style={{ marginInline: "2px" }}
          className={`frequency-button ${selected === "4" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("4");
          }}>
          Above 75%
        </button>
      </div>
    </div>
  );
};
const YourInvestmentObjectives = (props) => {
  const { t } = useTranslation();
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [InvestmentObjectives, setInvestmentObjectives] = useState([]);
  const [redirect, setRedirect] = useState(null);


  // useEffect(() => {
  //     fetchInvestmentObjectives();
  // }, [i18next.language]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedCheckboxes([...selectedCheckboxes, value]);
    } else {
      setSelectedCheckboxes(selectedCheckboxes.filter((item) => item !== value));
    }
  };

  const fetchInvestmentObjectives = async () => {
    ;
    try {
      const data = { FormType: "1", Lang: i18next.language === "ar" ? "AR" : "EN" };
      var response = utils.CallKYCAPI(Constants.GetInvesObjective, data);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
            setInvestmentObjectives(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return <SessionExpiredPOPup setRedirect={setRedirect} onClose={onClose} />;
              },
            });
          } else {
            setInvestmentObjectives([]);
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("setInvestmentObjectives", error);
        });
    } catch (error) {
      console.error("Error posting data setInvestmentObjectives:", error);
    }
  };

  useEffect(() => {
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (props.RequestItemsList !== undefined && props.RequestItemsList !== null) {
      if (props.RequestItemsList.length >= 1) {
        if (selectedCheckboxes.length === 0) {
          Helpers.errorNotify(t("Please fill Your Investment Objectives Data"), i18next.language);
          props.setRequestItemsList([]);
          props.setIsCallAPI(false);
          return false;
        }
      }
    }
    return true;
  }

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;
    var multiValue = "";
    if (selectedCheckboxes.length > 1) {
      for (var i = 0; i < selectedCheckboxes.length; i++) {
        multiValue = multiValue + selectedCheckboxes[i] + "/";
      }
    } else {
      multiValue = selectedCheckboxes[0];
    }

    var arr = props.RequestItemsList;
    arr.push({ ID: "64", Value: multiValue });
    props.setRequestItemsList(arr);
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }
  return (
    <div className="YourInvestmentObjectives-container">
      <h2>{t("investment_objectives")} </h2>

      <div className="checkbox-container">
        {/* {
                    InvestmentObjectives.map((obj) => {
                        return (
                            <label>
                                <input
                                    type="checkbox"
                                    value={obj.value}
                                    onChange={handleCheckboxChange}
                                />
                                {obj.Objective}
                            </label>

                        )
                    })
                } */}

        <label>
          <input type="checkbox" value="1" onChange={handleCheckboxChange} />
          {t("protect_capital_value")}
        </label>
        <label>
          <input type="checkbox" value="2" onChange={handleCheckboxChange} />
          {t("earn_steady_income")}{" "}
        </label>
        <label>
          <input type="checkbox" value="3" onChange={handleCheckboxChange} />
                  { t("long_term_savings")}
        </label>
        <label>
          <input type="checkbox" value="4" onChange={handleCheckboxChange} />
                  {t("grow_funds_exponentially") } {" "}
        </label>
      </div>
    </div>
  );
};

const InvestmentBar = (props) => {
  const { t } = useTranslation();
  const [equities, setEquities] = useState(0);
  const [fixedIncome, setFixedIncome] = useState(0);
  const [structuredProducts, setStructuredProducts] = useState(0);

  const handleChange = (setter) => (event, newValue) => {
    setter(newValue);
  };
  const marks = [
    { value: 0, label: "00" },
    { value: 1, label: "1Y" },
    { value: 2, label: "2Y" },
    { value: 3, label: "3Y" },
    { value: 4, label: "4Y" },
    { value: 5, label: ">5Y" },
  ];

  useEffect(() => {
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (props.RequestItemsList !== undefined && props.RequestItemsList !== null) {
      if (props.RequestItemsList.length >= 2) {
        if (equities === null || equities === "" || fixedIncome === "" || fixedIncome === null || structuredProducts === "" || structuredProducts === null) {
          Helpers.errorNotify(t("Please fill Investment Experience Data"), i18next.language);
          props.setRequestItemsList([]);
          props.setIsCallAPI(false);
          return false;
        }
      } else {
        props.setRequestItemsList([]);
        props.setIsCallAPI(false);
        return false;
      }
    }
    return true;
  }

  const saveKycDataFun = () => {
    if (!validateSubmit()) return;


     var result = Helpers.getScreenIdByGroupAndName("Risk Appetite");

        
    var arr = props.RequestItemsList;
    arr.push({ ID: "238", Value: equities + 1 });
    arr.push({ ID: "241", Value: fixedIncome + 1 });
    arr.push({ ID: "240", Value: structuredProducts + 1 });
    arr.push({ ID: "258", Value: "1" });
    arr.push({ID: "288", Value: result?.GROUP_ID || "" });
    arr.push({ID: "287", Value: result?.SCREEN_ID || "" });
    props.setRequestItemsList(arr);
    props.setIsCallAPIOnce(true);
  };

  return (
    <div className="InvestmentBar">
      <Box sx={{ width: "100%", margin: "0 auto", padding: "10px" }}>
        <h2> {props.title} </h2>
        <Box sx={{ marginBottom: "0px" }}>
                  <label>{ t("EquitiesandRelatedSecurities")}</label>
          <Slider
            value={equities}
            onChange={handleChange(setEquities)}
            step={1}
            marks={marks}
            min={0}
            max={5}
            valueLabelDisplay="auto"
            label={"30-35 min"}
            //   defaultValue={0}
            valueLabelFormat={(value) => (value > 0 ? `${value}Y` : "00")}
            sx={{ width: "100%" }}
            color={localStorage.getItem(Constants.localStorageConstants.company_name)?.toUpperCase() === "ADCB"? "#BA1B19" : "#0b1d81"}
          />
        </Box>

        <Box sx={{ marginBottom: "0px" }}>
          <label variant="subtitle1"> { t("FixedIncome")}</label>
          <Slider
            value={fixedIncome}
            onChange={handleChange(setFixedIncome)}
            step={1}
            marks={marks}
            min={0}
            max={5}
            valueLabelDisplay="auto"
            //   defaultValue={0}
            valueLabelFormat={(value) => (value > 0 ? `${value}Y` : "00")}
            sx={{ width: "100%" }}
            color={localStorage.getItem(Constants.localStorageConstants.company_name)?.toUpperCase() === "ADCB"? "#BA1B19" : "#0b1d81"}
          />
        </Box>

        <Box>
          <label variant="subtitle1"> { t("structured_product")} </label>
          <Slider
            value={structuredProducts}
            onChange={handleChange(setStructuredProducts)}
            step={1}
            marks={marks}
            min={0}
            max={5}
            valueLabelDisplay="auto"
            //   defaultValue={0}
            valueLabelFormat={(value) => (value > 0 ? `${value}Y` : "00")}
            sx={{ width: "100%" }}
            color={localStorage.getItem(Constants.localStorageConstants.company_name)?.toUpperCase() === "ADCB"? "#BA1B19" : "#BA1B19"}
          />
        </Box>
      </Box>
    </div>
  );
};

export default FatcaCRSDeclaration5;
